<template>
  <div>
    <rabbey-toolbox
      :call-new="callNew"
      :filterables="true"
      v-if="
        IsInRoles([
          roles.GerenteDeSoporte,
          roles.SuperUsuario,
          roles.EncargadaCompras,
          roles.GerenteRRHH,
          roles.SupervisorDeTécnicos,
          roles.GerenciaGeneral,
          roles.CoordinadorIso,
          roles.DirectorDeProyectos,
          roles.CoordinadorDeSoporte,
          roles.DirectorAdministrativo,
          roles.CoornidadorDeServicioAlCliente,
          roles.EncargadoDesarrolloDeAplicaciones,

          roles.CEO,
          roles.SupervisorDeSoporteDeVentas,
          roles.SupervisorDeVentas
        ])
      "
    >
      <!-- FILTRO DE COMPAÑIA -->
      <!-- <el-select
          v-model="companyId"
          class="box-item"
          size="mini"
          clearable
          @change="handleCompanyChange"
        >
          <el-option
            v-for="company in companyList"
            :key="company.value"
            :label="company.label"
            :value="company.value"
          ></el-option>
        </el-select> -->
    </rabbey-toolbox>
    <el-row>
      <el-col>
        <rabbey-table3
          ref="LegalTable"
          :loading="loading"
          :data="items"
          :actions="actions"
          :columns="columns"
          @rtable-push-action="actionHandler"
        />
      </el-col>
    </el-row>

    <el-drawer
      :title="
        this.selectedRowDocumentName
          ? 'Actualizar Documento: ' + this.selectedRowDocumentName
          : 'Nuevo Documento'
      "
      :visible.sync="legal_visible"
      size="20%"
    >
      <div
        class="flex gaps column demo-drawer__content border-myborder"
        style="padding: 20px"
      >
        <div id="div-legal">
          <NewLegal
            class="scrollable"
            style="max-height: 800px"
            :RowDocumentId="selectedRowId"
            :RowDocumentDueDate="selectedRowDueDate"
            Company="RB"
            @dialog-closed="handleDialogClose"
            @getData="getTableData"
          ></NewLegal>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import NewLegal from "@/views/modules/legal/documents/NewLegal.vue";

export default {
  label: "LEGAL",
  components: {
    NewLegal
  },
  data() {
    return {
      loading: false,
      items: [],
      search: "",
      documentId: 0,
      fileUrl: "",
      downloadFile: "",
      isPDF: false,
      documentDrawer: false,
      selectedRowId: 0,
      selectedRowDueDate: "",
      selectedRowDocumentName: "",
      companyId: "ALL",
      companyList: [
        { label: "MagyTrack", value: "MTR" },
        { label: "Tennos", value: "TB" },
        { label: "Rabbey", value: "RB" },
        { label: "Magycorp Technologies", value: "MTECH" },
        { label: "Magycorp SA", value: "MSA" }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-refresh",
          label: "Actualizar Documento",
          command: "update-document"
        }
      ],
      columns: [
        {
          prop: "Id",
          label: "NO",
          width: 80,
          sortable: true
        },
        {
          prop: "DocumentName",
          label: "Nombre del Documento",
          sortable: true
        },
        {
          prop: "CreatedAt",
          label: "Fecha de Creación",
          formatter: DatetimeFormatter
        },
        {
          prop: "DueDate",
          label: "Fecha de Vencimiento",
          sortable: true,
          formatter: DatetimeFormatter
        },
        {
          prop: "LastUpdated",
          label: "Última Actualización",
          formatter: DatetimeFormatter
        },
        {
          prop: "UpdatedByName",
          label: "Actualizado Por:"
        }
        // {
        //   prop: "AttachmentUrl",
        //   label: "Documento",
        //   width: 150,
        //   sortable: true,
        //   formatter: DownLoadFile
        // }
      ],
      legal_visible: false
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    getTableData(options) {
      if (!options) {
        options = {};
      }
      this.loading = true;

      this.$http
        .get("/api/LegalDocuments/GetLegalDocuments", {
          timeout: 3 * 60 * 1000,
          params: {
            companyId: this.companyId == 0 ? null : "RB"
          }
        })
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => (this.loading = false));
      this.selectedRowId = 0;
    },
    callNew() {
      this.legal_visible = true;
    },
    handleCompanyChange(company) {
      if (company) {
        this.companyId = company;
        this.getTableData();
      } else {
        this.companyId = "ALL";

        this.getTableData();
      }
    },
    actionHandler(action) {
      switch (action.command) {
        case "view": {
          window.open(action.row.DocumentURL, "_blank");
          break;
        }
        case "update-document": {
          if (
            this.IsInRoles([
              this.roles.GerenteDeSoporte,
              this.roles.SuperUsuario,
              this.roles.EncargadaCompras,
              this.roles.GerenteRRHH,
              this.roles.SupervisorDeTécnicos,
              this.roles.GerenciaGeneral,
              this.roles.CoordinadorIso,
              this.roles.DirectorDeProyectos,
              this.roles.CoordinadorDeSoporte,
              this.roles.DirectorAdministrativo,
              this.roles.CoornidadorDeServicioAlCliente,
              this.roles.EncargadoDesarrolloDeAplicaciones,

              this.roles.CEO,
              this.roles.SupervisorDeSoporteDeVentas,
              this.roles.SupervisorDeVentas
            ])
          ) {
            this.selectedRowId = action.row.Id;
            this.selectedRowDueDate = action.row.DueDate;
            this.selectedRowDocumentName = action.row.DocumentName;
            this.callNew();
          } else {
            this.$message.error(
              "No tienes permiso para actualizar este documento"
            );
          }
          break;
        }
      }
    },
    handleDialogClose() {
      this.legal_visible = false;
      this.selectedRowId = 0;
      this.selectedRowDocumentName = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
